import { useState } from "react";
import { supabase } from "../../lib/supabase";
import "./auth-styles.css";

export default function VerificationPage() {
  // Extract email query param if present
  const params = new URLSearchParams(window.location.search);
  const email = params.get("email") || "";

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleResend = async () => {
    if (!email) {
      setError("Email address is missing. Please sign up again.");
      return;
    }
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const { error: resendError } = await supabase.auth.resend({
        type: "signup",
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/coming-soon`,
        },
      });
      if (resendError) throw resendError;
      setSuccess("Verification email has been resent successfully!");
    } catch (err: any) {
      console.error("Resend verification failed:", err);
      setError(err.message || "Failed to resend verification email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="ambient-bg">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-logo">
            Huddlezen
            <span className="logo-dot"></span>
          </h1>
          <p className="auth-subtitle">Verify your email address</p>
        </div>

        {error && <div className="error-banner">{error}</div>}
        {success && <div className="success-banner">{success}</div>}

        <div style={{ textAlign: "center", marginBottom: "2rem", color: "#5A5449", fontSize: "0.95rem", lineHeight: "1.5" }}>
          We sent a verification link to <strong style={{ color: "#1A1A1A" }}>{email || "your inbox"}</strong>.
          Please click the link in the email to activate your account and access Huddlezen.
        </div>

        <button
          className="auth-btn auth-btn-primary"
          onClick={handleResend}
          disabled={loading || !email}
        >
          {loading ? "Resending..." : "Resend Verification Email"}
        </button>

        <div className="auth-footer">
          Need to change email or try again?
          <a className="auth-link" href="/signup">
            Sign Up
          </a>
        </div>
      </div>
    </div>
  );
}
